import {ElasticParser, ElasticSearchProperty} from '../factory.parsers';
import {buildAstroFiltQuery} from '../../query/elastic.queries';

export class AstrofiltParser implements ElasticParser {
  parseValue(polygon: string, elasticSearchProperty: ElasticSearchProperty): any {
    const {property} = elasticSearchProperty;
    return buildAstroFiltQuery(property, polygon);
  }
}
